import React from 'react';

import FormHierarchyField from './FormHierarchyField';
import {
  Sentry
} from '@gogame/components';

export const withFormField =
  (options = {}) =>
  (BaseComponent) => {
    const padding = options.hasOwnProperty('padding')
      ? options.padding
      : '16px 8px';
    const vertical = options.hasOwnProperty('vertical')
      ? options.vertical
      : true;

    return ({ children, ...props }) => (
      <Sentry.FormFieldErrorBoundary>
        <FormHierarchyField
          padding={padding}
          vertical={vertical}
          {...options}
          {...props}
        >
          {({ field, ...other }) => {
            const baseComponentProps = {
              ...other,
              ...field,
              'data-cy': field.name,
            };
            return <BaseComponent {...baseComponentProps} children={children} />;
          }}
        </FormHierarchyField>
      </Sentry.FormFieldErrorBoundary>
    );
  };

export default withFormField;
